import classNames from 'classnames';
import MakeHash from 'make-hash';
import React from 'react';
import {
    Redirect,
    Route,
    BrowserRouter as Router,
    Switch,
} from 'react-router-dom';

// Components
import Dialog from 'components/dialog';
import Footer from 'components/footer/footer';
import Nav from 'components/nav/nav';
//Services
import Endpoints from 'helpers/enums/endpoints';
import apiService from 'services/api-service';
import authService from 'services/auth-service';
// Firebase

class App extends React.Component {
    constructor(props) {
        super(props);

        // initializeFirebase();

        this.state = {
            authenticated: false,
            user: undefined,
            showNav: false,
            overlay_open: false,
            dialogHasX: true,
            dialogOpen: false,
            dialogView: null,
            dialogTheme: 'dark',
            siteTheme: 'dark',
            footerTheme: 'dark',
        };

        this.setUpHandlers();
        this.initializeServices();
    }

    /**
     * Binds any handlers to the correct context
     *
     * @method  setUpHandlers
     */
    setUpHandlers() {
        this.handleNavOpen = this.handleNavOpen.bind(this);
        this.toggleDialog = this.toggleDialog.bind(this);
        this.toggleFooterTheme = this.toggleFooterTheme.bind(this);
        this.toggleSiteTheme = this.toggleSiteTheme.bind(this);
        this.getUser = this.getUser.bind(this);
        this.setAuthState = this.setAuthState.bind(this);
        this.onUserFetchError = this.handleUserFetchError.bind(this);
    }

    /**
     * Initializes all services that will be used by app
     *
     * @method  initializeServices
     */
    initializeServices() {
        this.authService = authService;
        this.apiService = apiService;
    }

    /**
     * React Lifecycle Hook
     * Invoked once, immediately before mounting occurs. It is called before
     * render(), therefore setting state synchronously in this method will not
     * trigger a re-rendering.
     *
     * @method  componentWillMount
     */
    componentWillMount() {
        const tokenIsGood = this.authService.checkToken();
        this.setAuthState(tokenIsGood, () => {});
    }

    /**
     * This method toggles a flag that shows and hides the dialog
     *
     * @method toggleDialog
     *
     *
     */
    toggleDialog(view, hasX) {
        this.setState({
            dialogHasX: hasX,
            dialogOpen: !this.state.dialogOpen,
            dialogView: view,
        });
    }

    /**
     * This method toggles a flag that tells the app when the
     * mobile nav is open
     *
     * @method toggleDialog
     */
    handleNavOpen(isOpen) {
        this.setState({ navOpen: isOpen });
    }

    /**
     * This method gets information on the active user
     * base on the localStorage.token
     *
     * @method getUser
     */
    getUser() {
        this.apiService
            .get(Endpoints.user, this.onUserFetchError)
            .then((data) => {
                this.setState({
                    user: data,
                });
            });
    }

    handleUserFetchError(error) {
        this.setAuthState(false, () => {
            this.authService.removeToken();

            location.href = '/sign-in?error=userFetch';
        });
    }

    /**
     * This method toggles the theme for the site
     *
     * @method toggleSiteTheme
     *
     */
    toggleSiteTheme(theme) {
        this.setState({ siteTheme: theme });
    }

    /**
     * This method toggles the theme for the footer
     *
     * @method toggleFooterTheme
     *
     */
    toggleFooterTheme(theme) {
        this.setState({ footerTheme: theme });
    }

    setAuthState(isAuthenticated, callBack) {
        if (isAuthenticated) {
            this.setState(
                {
                    authenticated: true,
                    showNav: true,
                },
                () => {
                    this.getUser();
                    return callBack();
                }
            );
        } else {
            this.setState(
                {
                    authenticated: false,
                    user: null,
                    showNav: false,
                },
                callBack
            );
        }
    }

    _renderDialog() {
        const dialogClasses = classNames('dialog', {
            dialog_open: this.state.dialogOpen,
        });

        return !this.state.dialogView ? (
            ''
        ) : (
            <Dialog
                className={dialogClasses}
                hasX={this.state.dialogHasX}
                toggleDialog={this.toggleDialog}
                dialogView={this.state.dialogView}
            />
        );
    }

    _renderPrivateRoute(route, i) {
        return (
            <Route
                exact
                key={MakeHash(`${route.localizedName()}-${i}`)}
                path={route.path}
                render={(props) =>
                    this.state.authenticated ? (
                        <route.component
                            {...props}
                            apiService={this.apiService}
                            authService={this.authService}
                            setAuthState={this.setAuthState}
                            toggleDialog={this.toggleDialog}
                            toggleFooterTheme={this.toggleFooterTheme}
                            toggleSiteTheme={this.toggleSiteTheme}
                        />
                    ) : (
                        <Redirect
                            to={{
                                pathname: '/',
                                state: { from: props.location },
                            }}
                        />
                    )
                }
            />
        );
    }

    _renderPublicRoute(route, i) {
        let RouteComponent = route.component;

        if (route.path === '/') {
            RouteComponent = this.state.authenticated
                ? route.component.private
                : route.component.public;
        }

        return (
            <Route
                exact
                key={MakeHash(`${route.localizedName()}-${i}`)}
                path={route.path}
                render={(props) => {
                    return (
                        <RouteComponent
                            {...props}
                            apiService={this.apiService}
                            authService={this.authService}
                            setAuthState={this.setAuthState}
                            toggleDialog={this.toggleDialog}
                            toggleFooterTheme={this.toggleFooterTheme}
                            toggleSiteTheme={this.toggleSiteTheme}
                        />
                    );
                }}
            />
        );
    }

    render() {
        const { routes, onLocaleChange } = this.props;
        const siteClasses = classNames('site', {
            overlay_open: this.state.navOpen || this.state.dialogOpen,
        });

        return (
            <Router>
                <div className={siteClasses}>
                    <header className="site-header" role="banner">
                        <Nav
                            authService={this.authService}
                            setAuthState={this.setAuthState}
                            user={this.state.user}
                            handleNavOpen={this.handleNavOpen}
                            authenticated={this.state.showNav}
                            onLocaleChange={onLocaleChange}
                        />
                    </header>
                    <main id="main" className="site-content" role="main">
                        <Switch>
                            {routes.all.map((route, i) => {
                                return route.private
                                    ? this._renderPrivateRoute(route, i)
                                    : this._renderPublicRoute(route, i);
                            })}
                        </Switch>
                    </main>
                    <div className="site-footer">
                        <Footer
                            dark={this.state.footerTheme === 'dark'}
                            light={this.state.footerTheme === 'light'}
                            toggleDialog={this.toggleDialog}
                            onLocaleChange={onLocaleChange}
                        />
                    </div>
                    {this._renderDialog()}
                </div>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/client/app.jsx